import * as React from 'react';
import classnames from 'classnames';
import {useEffect, useRef} from 'react';

import {Tag} from "features/search/types";
import {getTypeName} from 'features/services/utils/name-helpers';
import {capitalizeFirstLetter, isDefined} from 'features/services/utils/helpers';

import './style.scss';

import {Icon} from 'components/atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';

interface Props {
    tag: Tag;
    ghost?: boolean;
    light?: boolean;
    onRemove?: (tag: Tag) => void;
    onClick?: () => void;
    getSize?: (size: DOMRect) => void;
    hideType?: boolean;
    hideRemove?: boolean;
    useName?: boolean;
}

export const SearchTag: React.FunctionComponent<Props> = ({tag, ghost, useName, light, onRemove, onClick, getSize, hideType, hideRemove}) => {
    const elementReference = useRef<HTMLDivElement>(null);
    const btnReference = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if(elementReference.current !== null && getSize) {
            getSize(elementReference.current.getBoundingClientRect());
        }
    }, [elementReference]);

    const onClickInternal = () => () => {
        if (onClick) onClick();
        if (onRemove) onRemove(tag);
    };

    if(!tag.type) return null;

    const tagButtonClasses = classnames(`search-tag tag-${tag.type.toLowerCase()}`, {
        'button--ghost--no-remove': !onRemove,
        'search-tag--clickable': isDefined(onClick),
    });

    return (
        <Button 
            buttonColor={light ? ButtonColor.LIGHT : ButtonColor.DEFAULT} 
            buttonSize={ButtonSize.SMALL} 
            buttonType={ghost ? ButtonType.GHOST : ButtonType.DEFAULT}
            className={tagButtonClasses}
            onClick={onClickInternal()}
            ref={btnReference}
            icon={onRemove && !hideRemove && <Icon name="x" size={16} />}
        >
            <span className="search-tag__value notranslate">
                {(tag.displayName && !useName) && tag.displayName}
                {(!tag.displayName || useName) && capitalizeFirstLetter(tag.name)} {!hideType && getTypeName(tag.type)}
            </span>
        </Button>
    );
};
